import Client from '../utilities/layout-filters/client';
import Renderer from '../utilities/layouts/renderer';
import Controller from '../utilities/layout-editor-base-controller'
import EventPublisher from '../utilities/event_publisher';
import { flashAlert } from '../shared/flash'

export default class extends Controller {
  static values = Object.assign(this.values, {
    startDate: String,
    endDate: String
  })

  connect() {
    this.loadLayout(Client, Renderer);
    window.addEventListener('position-selected', this.showProducts);
  }

  // overriding this here annoys me after making it take Client and Renderer so
  // i could keep it in base controller :(
  // gotta do it so Client can take a date though
  async loadLayout(FilterClient, FilterRenderer) {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    this.client = new FilterClient(this.layoutIdValue, this.destinationIdValue, token, this.startDateValue);
    const products = await this.client.fetchLayoutProducts();
    this.positions = await this.client.fetchPositions();
    this.landmarks = await this.client.fetchLandmarks();
    this.sections = await this.client.fetchSections();
    this.renderer = new FilterRenderer(this.layoutCanvasTarget, this.positions, this.landmarks);
    this.renderer.render();
    EventPublisher.publish('landmarks-loaded', { landmarks: this.landmarks });
    EventPublisher.publish('sections-loaded', { sections: this.sections });
    EventPublisher.publish('products-loaded', { products: products });
    EventPublisher.publish('positions-loaded', { positions: this.positions });
  }

  async handleSave() {
    const confirmed = confirm('Are you sure you want to save these changes?'); // eslint-disable-line no-alert
    if (!confirmed) return;
    const { response, error } = await this.client.saveLayout(this.positions, this.startDateValue, this.endDateValue);
    if (response) {
      EventPublisher.publish('layout-saved'); // just sets isDirty to false so we can leave without confirm
      window.location = `/destinations/${this.destinationIdValue}`;
    } else {
      flashAlert(error);
    }
  }
}
